module.exports = __webpack_public_path__ + "img/Backtotop.b85bbded.png";